import React from "react";
import { Check, Minus } from "lucide-react";

const ROWS = [
  ["A live guard watching, 24/7", true, false, false],
  ["Talks down intruders in real time", true, false, false],
  ["Prevents incidents — doesn't just record", true, false, false],
  ["Verified, eyes-on police dispatch", true, false, "partial"],
  ["Knows your residents, vehicles & vendors", true, false, false],
  ["Dedicated to your community", true, false, false],
  ["Licensed & insured (TX DPS)", true, "partial", "partial"],
];

const Cell = ({ v, highlight }) => {
  if (v === true)
    return (
      <span className={`inline-flex items-center justify-center w-7 h-7 rounded-full ${highlight ? "bg-[#D32F2F]" : "bg-[#0F172A]/10"}`}>
        <Check className={`w-4 h-4 ${highlight ? "text-white" : "text-[#0F172A]"}`} />
      </span>
    );
  if (v === "partial")
    return <span className="text-[12px] font-medium text-[#0F172A]/40">Limited</span>;
  return <Minus className="w-4 h-4 text-[#0F172A]/25 mx-auto" />;
};

const ComparisonTable = () => (
  <section id="difference" className="bg-white py-24 lg:py-32">
    <div className="max-w-5xl mx-auto px-6">
      <div data-reveal className="text-center max-w-2xl mx-auto mb-14">
        <div className="inline-flex items-center gap-2 mb-5 text-xs font-semibold uppercase tracking-[0.2em] text-[#D32F2F]">
          <span className="w-1.5 h-1.5 rounded-full bg-[#D32F2F]" /> The Redline Standard
        </div>
        <h2 className="font-head text-4xl sm:text-5xl font-semibold tracking-tight text-[#0F172A] leading-[1.05]">
          Why communities choose Redline.
        </h2>
        <p className="text-[#0F172A]/55 mt-5 text-lg">
          Cameras and apps tell you what already happened. A live guard stops it from happening at all.
        </p>
      </div>

      <div data-reveal className="overflow-x-auto rounded-2xl border border-[#0F172A]/[0.08] shadow-[0_24px_60px_-30px_rgba(15,23,42,0.3)]">
        <table className="w-full min-w-[560px] text-left">
          <thead>
            <tr className="bg-[#F8FAFC] border-b border-[#0F172A]/[0.08]">
              <th className="py-5 px-5 sm:px-7 text-[13px] font-semibold text-[#0F172A]/50 uppercase tracking-wide">Capability</th>
              <th className="py-5 px-3 text-center text-[13px] font-bold text-[#D32F2F] uppercase tracking-wide bg-[#D32F2F]/[0.06]">Redline</th>
              <th className="py-5 px-3 text-center text-[12px] font-semibold text-[#0F172A]/45 uppercase tracking-wide">Camera-only apps</th>
              <th className="py-5 px-3 text-center text-[12px] font-semibold text-[#0F172A]/45 uppercase tracking-wide">Traditional alarms</th>
            </tr>
          </thead>
          <tbody>
            {ROWS.map(([label, a, b, c], i) => (
              <tr key={i} className="border-b border-[#0F172A]/[0.05] last:border-0">
                <td className="py-4 px-5 sm:px-7 text-[14px] font-medium text-[#0F172A]">{label}</td>
                <td className="py-4 px-3 text-center bg-[#D32F2F]/[0.04]"><Cell v={a} highlight /></td>
                <td className="py-4 px-3 text-center"><Cell v={b} /></td>
                <td className="py-4 px-3 text-center"><Cell v={c} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </section>
);

export default ComparisonTable;
